<template>
	<div>
		<div class="modal" @click.self="close">
			<div>
				<div>
					<transition name="fade">
						<div class="modalbusyoverlay" v-if="isAppBusyModal">
							<div class="busyloader"><div><div></div><div></div><div></div><div></div></div></div>
						</div>
					</transition>
					<div>
						<a data-href @click.prevent="close">Luk</a>
						<h3 v-text="dialogTitle">
							Opret person
						</h3>
					</div>
					<section>
						<div>
							<form ref="form" @submit.prevent>
								<div class="notice" v-if="source">
									<strong>Kilde:</strong> {{ source }}
								</div>
								<div class="form-groups">

									<div class="form-group">
										<div class="input-group">
											<label>
												Aftale
											</label>

											<select v-model="agreementID" ref="agreementid">
												<option v-for="(agreement, index) in agreements" :key="index" v-bind:value="agreement.id">
													{{ agreement.name }}
												</option>
											</select><span></span>
										</div>

										<div class="input-group" ref="typegroup">
											<label for="type">
												Person type
											</label>
											<select v-model="type" ref="type">
												<option value="2">Barn</option>
												<option value="4">Medarbejder</option>
												<option value="3">Anden person</option>
											</select><span></span>
										</div>

										<div class="input-group" ref="persongroupidgroup">
											<label for="persongroupid">
												Gruppe
											</label>
											<select v-model="persongroupid" ref="persongroupid">
												<option v-for="(persongroup, index) in (filteredGroups)" :key="index" v-bind:value="persongroup.id">
													{{ persongroup.name }}
												</option>
											</select><span></span>
										</div>
									</div>
									<div class="form-group">
										<div class="input-group" ref="externalidgroup">
											<label for="externalid">
												Eksternt ID
											</label>
											<input v-model="externalid" type="text" ref="externalid" value>
										</div>

										<div class="input-group" ref="externalidparsedgroup">
											<label for="externalidparsed">
												Behandlet eksternt ID
											</label>
											<input v-model="externalidparsed" type="text" ref="externalidparsed" value>
										</div>

									</div>

									<div class="form-group" v-if="dialogMode != 'create' && type==2" v-show="false">
										<div class="input-group">
											<label for="agreement">
												Hent bestillings talon
											</label>
											<div class="input-group-hori">
												<div ref="pdfagreementwrapper">
													<select v-model="pdfagreementid" ref="pdfagreementid">
														<option v-if="agreements.length == 0" value="0">Ingen aftaler fundet</option>
														<option v-if="agreements.length > 1" value="0">Vælg aftale</option>
														<option v-for="(agreement, index) in agreements" :key="index" v-bind:value="agreement.id">
															{{ agreement.name }}
														</option>
													</select><span></span>
												</div>
												<div>
													<button type="button" class="small outline" :disabled="pdfagreementid == 0" ref="getPDFButton" @click.prevent="getPDF">
														Hent PDF
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="divider"></div>

								<div class="form-groups">

									<div class="form-group">
										<div class="input-group" ref="firstnamegroup">
											<label for="firstname">
												Fornavn
											</label>
											<input v-model="firstname" type="text" ref="firstname" value>
										</div>

										<div class="input-group" ref="lastnamegroup">
											<label for="lastname">
												Efternavn
											</label>
											<input v-model="lastname" type="text" ref="lastname" value>
										</div>

										<div class="input-group" ref="birthdatestringgroup" v-if="type == 2">
											<label for="birthdatestring">
												Fødselsdato
											</label>
											<input v-model="birthdatestring" type="text" ref="birthdatestring" value>
										</div>
									</div>

									<div class="form-group" v-if="type != 2">
										<div class="input-group" ref="emailaddressgroup">
											<label for="emailaddress">
												Email
											</label>
											<input v-model="emailaddress" type="email" ref="emailaddress" value autocomplete="off">
										</div>

										<div class="input-group" ref="initialsgroup">
											<label for="initials">
												Initialer
											</label>
											<input v-model="initials" type="text" ref="initials" value>
										</div>
									</div>

									<div class="form-group" v-if="type == 2 || type == 3">
										<div class="input-group" ref="addressgroup">
											<label for="address">
												Adresse
											</label>
											<input v-model="address" type="text" ref="address" value>
										</div>

										<div class="input-group" ref="zipcodegroup">
											<label for="zipcode">
												Postnummer
											</label>
											<input v-model="zipcode" type="text" ref="zipcode" value>
										</div>

										<div class="input-group" ref="citygroup">
											<label for="city">
												By
											</label>
											<input v-model="city" type="text" ref="city" value>
										</div>
									</div>
								</div>

								<div class="divider" v-if="type != 1"></div>

								<h3>Webshop information</h3>

								<div class="spacer"></div>

								<div class="form-groups" v-if="type != 1">
									<div class="form-group">
										<div class="input-group" ref="clientnamegroup">
											<label for="clientname">
												Navn
											</label>
											<input v-model="clientname" type="email" ref="clientname">
										</div>

										<div class="input-group" ref="clientemailaddressgroup">
											<label for="clientemailaddress">
												Email
											</label>
											<input v-model="clientemailaddress" type="email" ref="clientemailaddress" value autocomplete="off">
										</div>

										<div class="input-group" ref="clientmobilenumbergroup">
											<label for="clientmobilenumber">
												Mobilnummer
											</label>
											<input v-model="clientmobilenumber" type="text" ref="clientmobilenumber" value>
										</div>
									</div>

									<div class="form-group" v-if="personHasCancelledStatus">
										<div class="input-group" ref="statusgroup">
											<label for="status">
												Status
											</label>
											<p>
												Kunden har afvist billederne.
											</p>
											<button style="width: 200px;" class="small" @click.prevent="resetPersonStatus">Nulstil person status</button>
										</div>
									</div>
								</div>

								<div class="divider"></div>
								<div class="buttons-group">
									<button type="button" @click.prevent="deleteData" class="delete left" v-if="dialogMode == 'edit'">
										Slet
									</button>
									<button type="button" @click.prevent="close" class="text space">
										Tilbage
									</button>
									<button type="button" @click.prevent="saveData">
										Gem
									</button>
								</div>
							</form>
						</div>
					</section>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { types } from "@/app/types/types"
	import { appFeedbackStateEnum, personStatusTypeEnum } from "@/app/enums/common"

	export default {
		name: "PersonEdit",
		data()
		{
			return {
				dialogMode: "create",
				dialogTitle: "Opret person",
				customerID: 0,
				personID: 0,
				pdfagreementid: 0,
				customer: null,
				persongroups: null,
				agreements: null,

				persongroupid: 0,
				persongroupidref: 0,
				source: "",
				agreementID: 0,
				externalid: "",
				externalidparsed: "",
				type: "2",
				firstname: "",
				lastname: "",
				clientname: "",
				clientemailaddress: "",
				clientmobilenumber: "",
				initials: "",
				birthdatestring: "",
				address: "",
				zipcode: "",
				city: "",
				startdate: null,
				expirationdate: null,
				status: 0,

				person: {
					persongroupid: "",
					agreementid: 0,
					externalid: "",
					externalidparsed: "",
					type: "2",
					firstname: "",
					lastname: "",
					clientname: "",
					clientemailaddress: "",
					clientmobilenumber: "",
					initials: "",
					birthdatestring: "",
					address: "",
					zipcode: "",
					city: "",
					startdate: null,
					expirationdate: null,
					status: 0
				}
			}
		},
		async mounted()
		{
			this.setModalIsVisible()
			this.customerID = this.$route.params.customerid
			this.agreementID = this.$route.params.agreementid
			this.personID = this.$route.params.personid
			this.persongroupidref = this.$route.params.persongroupid
			this.setAppAsBusyModal()

			try
			{
				// Get customer
				var customerResult = await this.$store.dispatch(types.ACTION_GET_CUSTOMER, this.customerID)

				if (customerResult.status == 200)
				{
					this.customer = customerResult.data

					// Get groups
					let data = { customerid: this.customerID, agreementid: this.agreementID }
					var personGroupsResult = await this.$store.dispatch(types.ACTION_GET_PERSONGROUPS, data)

					if (personGroupsResult.status == 200)
					{
						this.persongroups = personGroupsResult.data

						// Get agreements
						let searchdata = { customerID: this.customerID, status: 0, period: 0 }
						var agreementsResult = await this.$store.dispatch(types.ACTION_GET_AGREEMENTS, searchdata)

						if (agreementsResult.status == 200)
						{
							this.agreements = agreementsResult.data

							if (this.agreements && this.agreements.length == 1)
							{
								this.pdfagreementid = this.agreements[0].id
								this.agreementID = this.agreements[0].id
							}

							if (this.$route.name == "PersonEdit")
							{
								this.dialogMode = "edit"
								this.dialogTitle = "Rediger person"
								this.personID = this.$route.params.personid
								this.loadData()
								this.setAppAsIdle()
							}
							else
							{
								this.dialogMode = "create"
								this.dialogTitle = "Opret person"
								this.$refs.externalid.focus()
								this.setAppAsIdle()
							}
						}
						else
						{
							this.setAppAsIdle()
							logError("PersonEdit.loadData() getAgreements", error)
							alert("Der opstod en fejl. Opdater siden og prøv igen.")
							this.$router.push({ name: "PersonGroups" })
						}
					}
					else
					{
						this.setAppAsIdle()
						logError("PersonEdit.loadData() getgroups", error)
						alert("Der opstod en fejl. Opdater siden og prøv igen.")
						this.$router.push({ name: "PersonGroups" })
					}
				}
				else
				{
					this.setAppAsIdle()
					logError("PersonEdit.loadData() getcustomer", error)
					alert("Der opstod en fejl. Opdater siden og prøv igen.")
					this.$router.push({ name: "PersonGroups" })
				}
			}
			catch (error)
			{
				this.setAppAsIdle()
				logError("PersonEdit.loadData()", error)
				this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
				this.$router.push({ name: "PersonGroups" })
			}
		},
		computed:
		{
			personHasCancelledStatus()
			{
				return this.status == personStatusTypeEnum.CANCELLED
			},
			filteredGroups()
			{
				if (!this.persongroups)
					return []

				var groups = this.persongroups.filter((data) =>
				{
					if (data.type == this.type || this.type == 3)
					{
						return data
					}
				})

				if (groups && groups.length == 1)
				{
					// eslint-disable-next-line
					this.persongroupid = groups[0].id
				}

				return groups
			}
		},
		destroyed()
		{
			this.setModalNotVisible()
		},
		methods:
		{
			async resetPersonStatus()
			{
				var result = await this.$store.dispatch(types.ACTION_RESETPERSON_STATUS, {
					personid: this.personID,
					status: personStatusTypeEnum.READYCLIENTNOTIFIED
				})

				if (result.status == 200)
				{
					this.status = personStatusTypeEnum.READYCLIENTNOTIFIED
					this.setAppAsIdle()
					this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
				}
				else
				{
					this.$refs.pdfagreementwrapper.setAttribute("data-error", "Der opstod en fejl ved nulstilling af personens status. Opdater siden og prøv igen.")
					this.setAppAsIdle()
				}
			},
			async getPDF()
			{
				this.setAppAsBusyModal()
				this.$refs.pdfagreementwrapper.removeAttribute("data-error")

				var result = await this.$store.dispatch(types.ACTION_DOWNLOAD_ORDERING_PDF_PERSON, {
					personid: this.personID,
					agreementid: this.pdfagreementid,
					filename: "ImageMakersBestillingsTalon_" + this.customer.name.replace(" ", "_") + "-" + this.pdfagreementid + "_" + this.externalidparsed + "-" + this.personID + ".pdf"
				})

				if (result.status == 200)
				{
					this.setAppAsIdle()
				}
				else
				{
					this.$refs.pdfagreementwrapper.setAttribute("data-error", "Der opstod en fejl ved generering af PDF. Opdater siden og prøv igen.")
					this.setAppAsIdle()
				}
			},
			checkForChanges()
			{
				var changes = false

				changes = changes || (this.type != this.person.type)
				changes = changes || (this.externalid != this.person.externalid)
				changes = changes || (this.externalidparsed != this.person.externalidparsed)
				changes = changes || (this.firstname != this.person.firstname)
				changes = changes || (this.lastname != this.person.lastname)
				changes = changes || (this.clientemailaddress != this.person.clientemailaddress)
				changes = changes || (this.clientmobilenumber != this.person.clientmobilenumber)
				changes = changes || (this.clientname != this.person.clientname)

				// Employees
				if (this.type == 4)
				{
					changes = changes || (this.initials != this.person.initials)
				}

				// Children
				if (this.type == 2)
				{
					changes = changes || (this.birthdatestring != this.person.birthdatestring)
					changes = changes || (this.address != this.person.address)
					changes = changes || (this.zipcode != this.person.zipcode)
					changes = changes || (this.city != this.person.city)
					changes = changes || (this.mobilenumber != this.person.mobilenumber)
				}

				if (changes)
				{
					return !confirm("Der er ændringer der ikke er gemt. Vil du lukke dialogen?")
				}

				return false
			},
			close()
			{
				if (this.checkForChanges())
				{
					return
				}

				if (this.dialogMode == "edit")
				{
					if (this.persongroupidref && this.persongroupidref != 0)
					{
						this.$router.push({ name: "PersonGroupShow", params: { persongroupid: this.persongroupidref, customerid: this.customerID, agreementid: this.agreementID } })
					}
					else
					{
						this.$router.push({ name: "Persons", params: { customerid: this.customerID, agreementid: this.agreementID } })
					}
				}
				else
				{
					this.$router.push({ name: "Agreements", params: { customerid: this.customerID, agreementid: this.agreementID } })
				}
			},
			async loadData()
			{
				if (this.personID)
				{
					this.setAppAsBusyModal()

					try
					{
						var result = await this.$store.dispatch(types.ACTION_GET_PERSON, this.personID)

						if (result.status == 200)
						{
							this.person = result.data.information
							this.person.type = result.data.type
							this.type = result.data.type
							this.source = result.data.information.source
							this.agreementID = result.data.agreementid

							if (this.agreementID == 0 && this.agreements && this.agreements.length > 0)
							{
								this.agreementID = this.agreements[0].id
							}

							this.externalid = result.data.information.externalid
							this.externalidparsed = result.data.information.externalidparsed
							this.firstname = result.data.information.firstname
							this.lastname = result.data.information.lastname
							this.clientname = result.data.information.clientname
							this.clientemailaddress = result.data.information.clientemailaddress
							this.clientmobilenumber = result.data.information.clientmobilenumber
							this.initials = result.data.information.initials
							this.birthdatestring = result.data.information.birthdatestring
							this.address = result.data.information.address
							this.zipcode = result.data.information.zipcode
							this.city = result.data.information.city
							this.startdate = result.data.startdate
							this.expirationdate = result.data.expirationdate
							this.status = result.data.status

							if (result.data.persongroups && result.data.persongroups.length > 0)
							{
								this.persongroupid = result.data.persongroups[0].persongroupid
							}

							this.setAppAsIdle()
						}
						else
						{
							this.setAppAsIdle()
							logError("PersonEdit.loadData()", error)
							alert("Der opstod en fejl. Opdater siden og prøv igen.")
							this.$router.push({ name: "Persons" })
						}
					}
					catch (error)
					{
						this.setAppAsIdle()
						logError("PersonEdit.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
						this.$router.push({ name: "Persons" })
					}
				}
				else
				{
					alert("Forkert adresse. Opdater venligst siden, og prøv igen. 4")
					this.$router.push({ name: "Persons" })
				}
			},
			async saveData()
			{
				try
				{
					var valid = true
					var validationFocus = false

					if (this.persongroupid.length == 0 || this.persongroupid == 0)
					{
						this.$refs.persongroupidgroup.setAttribute("data-validation", "Vælg venligst en gruppe")
						this.$refs.persongroupid.focus()
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.persongroupidgroup.removeAttribute("data-validation")
					}


					if (this.firstname.length == 0)
					{
						this.$refs.firstnamegroup.setAttribute("data-validation", "Indtast venligst et fornavn")
						valid = false

						if (!validationFocus)
						{
							this.$refs.firstname.focus()
							validationFocus = true
						}
					}
					else
					{
						this.$refs.firstnamegroup.removeAttribute("data-validation")
					}

					if (this.lastname.length == 0)
					{
						this.$refs.lastnamegroup.setAttribute("data-validation", "Indtast venligst et efternavn")
						valid = false

						if (!validationFocus)
						{
							this.$refs.lastname.focus()
							validationFocus = true
						}
					}
					else
					{
						this.$refs.lastnamegroup.removeAttribute("data-validation")
					}

					// Employee validation
					if (this.type != 2)
					{
						if (this.emailaddress.length == 0)
						{
							this.$refs.emailaddressgroup.setAttribute("data-validation", "Indtast venligst en korrekt e-mail adresse")
							valid = false

							if (!validationFocus)
							{
								this.$refs.emailaddress.focus()
								validationFocus = true
							}
						}
						else
						{
							this.$refs.emailaddressgroup.removeAttribute("data-validation")
						}

						if (this.initials.length == 0)
						{
							this.$refs.initialsgroup.setAttribute("data-validation", "Indtast venligst personens initialer")
							valid = false

							if (!validationFocus)
							{
								this.$refs.initials.focus()
								validationFocus = true
							}
						}
						else
						{
							this.$refs.initialsgroup.removeAttribute("data-validation")
						}
					}

					// Child validation
					if (this.type != 4)
					{
						if (this.address.length == 0)
						{
							this.$refs.addressgroup.setAttribute("data-validation", "Indtast venligst en adresse")
							valid = false

							if (!validationFocus)
							{
								this.$refs.address.focus()
								validationFocus = true
							}
						}
						else
						{
							this.$refs.addressgroup.removeAttribute("data-validation")
						}

						if (this.zipcode.length == 0)
						{
							this.$refs.zipcodegroup.setAttribute("data-validation", "Indtast venligst et postnummer")
							valid = false

							if (!validationFocus)
							{
								this.$refs.zipcode.focus()
								validationFocus = true
							}
						}
						else
						{
							this.$refs.zipcodegroup.removeAttribute("data-validation")
						}

						if (this.city.length == 0)
						{
							this.$refs.citygroup.setAttribute("data-validation", "Indtast venligst en by")
							valid = false

							if (!validationFocus)
							{
								this.$refs.city.focus()
								validationFocus = true
							}
						}
						else
						{
							this.$refs.citygroup.removeAttribute("data-validation")
						}
					}

					if (!valid)
					{
						return
					}

					this.setAppAsBusyModal()

					var data =
					{
						id: this.personID,
						customerid: this.customerID,
						agreementid: this.agreementID,
						startdate: this.startdate,
						expirationdate: this.expirationdate,
						type: this.type,
						persongroups: [
							{
								persongroupid: this.persongroupid,
								personid: this.personID
							}
						],
						information:
						{
							externalid: this.externalid,
							externalidparsed: this.externalidparsed,
							firstname: this.firstname,
							lastname: this.lastname,
							clientname: this.clientname,
							clientemailaddress: this.clientemailaddress,
							clientmobilenumber: this.clientmobilenumber,
							initials: this.initials,
							birthdatestring: this.birthdatestring,
							address: this.address,
							zipcode: this.zipcode,
							city: this.city
						}
					}

					if (this.dialogMode == "edit")
					{
						var result = await this.$store.dispatch(types.ACTION_UPDATE_PERSON, data)

						if (result.status == 200)
						{
							this.person = result.data
							this.setAppAsIdle()
							this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)

							if (this.persongroupidref && this.persongroupidref != 0)
							{
								this.$router.push({ name: "PersonGroupShow", params: { persongroupid: this.persongroupidref, customerid: this.customerID, agreementid: this.agreementID } })
							}
							else
							{
								this.$router.push({ name: "Persons", params: { updatedPerson: this.person, customerid: this.customerID, agreementid: this.agreementID } })
							}
						}
						else if (result.status == 400)
						{
							this.setAppAsIdle()

							if (result.data && result.data.ErrorCode && result.data.ErrorCode == "NameInUse")
							{
								this.$refs.namegroup.setAttribute("data-validation", "Der findes allerede en gruppe med navnet " + this.name + ". Indtast venligst et andet navn.")
								this.$refs.name.focus()
							}
							else
							{
								// Tjek for brugt email
								log("Update error: " + result.data.message)
								alert("Der opstod en fejl. Opdater siden og prøv igen.")
							}
						}
						else
						{
							this.setAppAsIdle()
							logError("Person.saveData()", result.status)
							alert("Der opstod en fejl. Opdater siden og prøv igen.")
						}
					}
					else
					{
						var result = await this.$store.dispatch(types.ACTION_ADD_PERSON, data)

						if (result.status == 201)
						{
							this.person = result.data
							this.setAppAsIdle()
							this.setAppFeedbackState(appFeedbackStateEnum.ADDED)
							this.$router.push({ name: "Persons", params: { addedPerson: this.person } })
						}
						else if (result.status == 400)
						{
							this.setAppAsIdle()

							if (result.data && result.data.ErrorCode && result.data.ErrorCode == "NameInUse")
							{
								this.$refs.namegroup.setAttribute("data-validation", "Der findes allerede en gruppe med navnet " + this.name + ". Indtast venligst et andet navn.")
								this.$refs.name.focus()
							}
							else
							{
								log("Update error: " + result.data.message)
								alert("Der opstod en fejl. Opdater siden og prøv igen.")
							}
						}
						else
						{
							this.setAppAsIdle()
							logError("Person.saveData()", error)
							alert("Der opstod en fejl. Opdater siden og prøv igen.")
						}
					}
				}
				catch (ex)
				{
					this.setAppAsIdle()
				}
			},
			async deleteData()
			{
				if (confirm("Er du sikker? Sletningen kan ikke fortrydes."))
				{
					try
					{
						await this.$store.dispatch(types.ACTION_DELETE_PERSON, this.personID)
							.then(response =>
							{
								this.setAppAsIdle()
								this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
								this.$router.push({ name: "Persons" })
							})
							.catch(error =>
							{
								this.setAppAsIdle()
								logError("Person.deleteData()", error)
								this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
							})
					}
					catch (error)
					{
						this.setAppAsIdle()
						logError("Person.deleteData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
						this.$router.push({ name: "Persons" })
					}
				}
			},
		}
	}
</script>